import { useEffect } from "react";

const SITE = "https://www.agendauni.com.br";

// Atualiza (ou cria) uma <meta> por name/property no <head>.
function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * SEO por página, em JS nativo (sem react-helmet — incompatível com React 19).
 * O index.html já entrega o card base estático para os buscadores; este hook
 * refina título/descrição/canonical quando o usuário navega no SPA.
 *
 * @param {{ title: string, description?: string, path?: string, noindex?: boolean }} cfg
 */
export function usePageSeo({ title, description, path = "/", noindex = false }) {
  useEffect(() => {
    const url = `${SITE}${path}`;
    document.title = title;

    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setCanonical(url);
    setMeta(
      "name",
      "robots",
      noindex ? "noindex, follow" : "index, follow, max-image-preview:large"
    );
  }, [title, description, path, noindex]);
}
